module.exports = __webpack_public_path__ + "static/img/pic_rjyf_rjys_bzzj@2x.d1bdfdab.png";